import type { FaireProductEntity } from "../../entity_types/product";

export const p_bn4edz5hdq: FaireProductEntity = {
  token: "p_bn4edz5hdq",
  type: "product",
  name: "OVERSIZE Christmas Sweater with Lettering",
  brandToken: "b_8emw35kxrq",
  brandName: "Mello.",
  imageUrl:
    "https://cdn.faire.com/fastly/66af07459dfc819c7ee678197a03e281bcbac70d0d3e696505bc44f4058ddf2f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea52594db1e19dc801b71ecb83afa689cb8b6cb977f9769a42ff786607c979a1.jpeg",
    "https://cdn.faire.com/fastly/cd5443263e2c5af41b7ec2cba4091817f3d0384b7bdaf5d7d122e3c0de57272a.jpeg",
    "https://cdn.faire.com/fastly/6f2fae4711ed816f0e440c66769519d547dc1804e0823adda5b60479eebe3f2d.jpeg",
    "https://cdn.faire.com/fastly/4b28551716a1d307e270d344bc1e6fbf4534441acdc58c15f48f73e969eea8f1.jpeg",
    "https://cdn.faire.com/fastly/3b2cd0fa7cccec72ad50317c4d2c772f45a6c6a46a9f0005d45b23cd6d6e10d3.jpeg",
    "https://cdn.faire.com/fastly/039dda4fe1fab2a63343a1719b81dc6d58c91aa3247ffb1b1c7480b8d82d953f.jpeg",
    "https://cdn.faire.com/fastly/e36a01f3e1ccd8f80869184dead07813e45e2dcd5a4f832f18321b00622da91d.jpeg",
    "https://cdn.faire.com/fastly/6fb320677f2fde3ea2cc16b5abb3ae864e1f700daa4b394718b13219ff1cfdf1.jpeg",
    "https://cdn.faire.com/fastly/4cbfff5ff4f244bf3cdcd29f1f5b49708e37a24d78dc885b30b63ea71f15ea04.jpeg",
    "https://cdn.faire.com/fastly/b3a5f3d7b9d72c8492caca69ccdcdfde2ed761cc873ce2b54fa4686663a8191f.jpeg",
    "https://cdn.faire.com/fastly/cfd39c90aff351e748cc06bbaffab1f918b900bed0cce7a5515ea96de96411e7.jpeg",
  ],
  priceDollars: 176.4,
  description:
    "OVERSIZE Christmas Sweater with Lettering\n\nSize : Small \n\nActual product color may vary from the images shown. Every monitor or mobile display has a different capability to display colors, and every individual may see these colors differently.",
  tags: [],
  msrpDollars: 352.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:29.906Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
